import axios from 'axios'

export default class StorageService {
  constructor() {
    this.axios = axios.create({
      baseURL: process.env.VUE_APP_KONTIGO_BASE_API_URL,
    })
  }

  async upload(file, bucket) {
    const { data: { url: preSignedPutUrl } } = await this.axios.post('generatePreSignedPutUrl', {
      filename: file.name,
      contentType: file.type,
      bucket,
    })

    const preSignedPutUrlAsURL = new URL(preSignedPutUrl)

    const key = preSignedPutUrlAsURL.pathname.substring(1)

    await axios({
      url: preSignedPutUrl,
      method: 'PUT',
      data: file,
      headers: {
        'Content-Type': file.type,
      },
    })

    return key
  }

  async getUrl(key, bucket) {
    const { data: { url } } = await this.axios.post('generatePreSignedGetUrl', {
      key,
      bucket,
    })

    return url
  }
}
